// Slug del evento desde la URL (/e/<slug>/...). Solo en cliente (handlers/effects).
export function slugActual(): string {
  if (typeof window === "undefined") return "";
  return window.location.pathname.match(/^\/e\/([^/]+)/)?.[1] ?? "";
}
// Ruta interna del evento actual: ruta("/comandas") -> /e/<slug>/comandas
export function ruta(p: string): string {
  const s = slugActual();
  return s ? `/e/${s}${p === "/" ? "" : p}` : p;
}
